<template>
	<Link :href="'/'">
		<img src="/images/logomark-meshworks-black.png" width="120" />
	</Link>
</template>

<script>
	import { Link } from '@inertiajs/inertia-vue3';

	export default {
		components: {
			Link,
		},
	}
</script>

<style lang="sass" scoped>

img
	margin-bottom: 40px

</style>
